// extracted by mini-css-extract-plugin
export default {"fullboxBg":"Mypage_fullboxBg__-DT3w","fullbox":"Mypage_fullbox__m-mOR","myInform":"Mypage_myInform__bzEn4","mySchedule":"Mypage_mySchedule__tjs20"};